import type { CSSProperties } from "react";
import { siteConfig } from "../../config/site";

export function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-white">
      {/* Decorative blurred bubbles */}
      <span className="pointer-events-none absolute -left-[100px] top-[80px] h-[380px] w-[380px] rounded-full bg-[#f9f3ff] opacity-70 blur-[60px]" />
      <span className="pointer-events-none absolute -right-[100px] top-[140px] h-[400px] w-[400px] rounded-full bg-[#f9f3ff] opacity-70 blur-[60px]" />

      <div className="relative z-10 mx-auto flex w-full max-w-[1440px] flex-col items-center gap-7 px-4 pb-10 pt-16 text-center sm:pb-14 sm:pt-24">
        <span className="reveal reveal-1 rounded-full bg-[#ede9fe] px-5 py-2 text-xs font-semibold uppercase tracking-[0.6px] text-brand-purple">
          About GenZ Paisa
        </span>

        <h1 className="max-w-[960px] text-4xl font-extrabold leading-tight tracking-[-1px] sm:text-6xl lg:text-[64px] lg:leading-[68px]">
          <div className="reveal-mask">
            <span
              className="block text-brand-purple"
              style={{ "--reveal-delay": "0.15s" } as CSSProperties}
            >
              Your Goals,
            </span>
          </div>
          <div className="reveal-mask">
            <span
              className="block text-brand-teal"
              style={{ "--reveal-delay": "0.25s" } as CSSProperties}
            >
              Our Commitment.
            </span>
          </div>
        </h1>

        <p className="reveal reveal-3 max-w-[672px] text-base leading-7 text-[#475569] sm:text-lg">
          At Genz Paisa, we believe getting financial support shouldn&apos;t
          feel complicated. We&apos;re building a simple, digital-first loan
          experience that helps people explore borrowing options, understand
          their terms, and make informed financial decisions.
        </p>

        <a
          href={siteConfig.applyLink || undefined}
          target="_blank"
          rel="noopener noreferrer"
          className="reveal reveal-4 flex items-center gap-2 rounded-full bg-[#311042] px-8 py-[14px] text-sm font-semibold text-white shadow-[0px_1px_1px_rgba(0,0,0,0.05)] transition-opacity hover:opacity-90"
        >
          Learn More About Us
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </section>
  );
}
